import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service'
import { Tag, TagsUsage } from '../models';

@Injectable({
    providedIn: 'root'
})
export class TagsService {

    constructor(private httpService: JsonHttpService) { }

    getTags(usage: TagsUsage): Promise<Tag[]> {
        const options = { params: new HttpParams().set('usage', TagsUsage[usage]) };
        return this.httpService.get('/api/tags/get-tag', options).toPromise();
    }

    saveTag(tag: Tag): Promise<Tag> {
        return this.httpService.post('/api/tags/save-tag', tag).toPromise();
    }

    deleteTag(tagId: number, cascade: boolean, useGenericErrorHandling: boolean): Promise<void> {
        const options = {
            params: new HttpParams()
                .set('TagsId', `${tagId}`)
                .set('CascadeDelete', `${cascade}`)
        };
        return this.httpService.post('/api/tags/delete-tag', null, options, useGenericErrorHandling).toPromise();
    }
}
